import { moveMediaElementZindexDownAction } from 'editor/src/store/design/slice';
import { ElementAddress } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const moveMediaElementZindexDownOperation = (elementAddress: ElementAddress) => (dispatch: ThunkDispatch) =>
  dispatch(moveMediaElementZindexDownAction(elementAddress));

export default moveMediaElementZindexDownOperation;
